import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { DownloadLink } from 'src/app/_models/downloadLinks.vm';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-download-link',
    templateUrl: './download-link.component.html',
    styleUrls: ['./download-link.component.scss'],
    standalone: false
})
export class DownloadLinkComponent {

  @Input() public downloadLink: DownloadLink

}
